module.exports = {
  Root: {
    Basic: {
      Failed: "失败",
      Success: "成功",
      Result: "结果",
      Select: "选择",
      Cancel: "取消",
      Confirm: "确定",
      OK: "好",
      Ok: "好",
      Tips: "提示",
      Warning: "警告",
      Method: "方法",
      Required: "必填项",
      MaxLength: "长度限制在{num}字符以内",
      Submit: "提交",
      Search: "搜索",
      Reset: "重置",
      More: "更多",
      Back_to_Homepage: "返回首页",
      delete: "删除",
      no: "不",
      all_read: "全部已读",
      empryMsg: "暂无消息"
    },
    Import: {
      Job: "任务",
      No: "编号",
      row_of_sheet: "所在行",
      reason_of_fails: "失败的原因",
      File: "文件",
      no_data: "没有数据",
      import: "导入",
      upload: "上传",
      refresh: "刷新",
      refresh_notice: "单击“刷新”以查看最新状态",
      view_result: "查看结果",
      Started_at: "开始于",
      Status: "状态",
      total_count: "总数",
      error_count: "错误总数",
      success_count: "成功总数",
      Action: "操作",
      got_it: "我知道了",
      execution_history: "执行历史",
      import_history: "导入历史",
      download_template: "下载模板",
      job_description: "任务描述",
      import_products: "导入商品",
      import_completed_at: "导入完成于",
      importing: "导入中，烦请耐心等待片刻，导入结果将会展示在执行历史列表中。",
      import_products_desc:
        "你可以将商品信息导入到PIM系统中，在操作之前，我们建议你首先下载导入数据的模板以供参考。",
      select_a_file: "请先选择一个文件",
      Please_select_an_org: "请先选择一个组织",
      rules_title: "导入规则",
      import_run_tip: "当导入运行时，您无法查看结果。",
      Please_confirm_the_org: "请确认向需要的组织导入",
      Confirme_or_switch_org: "确认或切换组织",
      Import_Products: "导入产品",
      Import_SKU: "导入SKU",
      Import_Price: "导入价格",
      Import_Image: "导入图片",
      Import_Channel_Info: "导入渠道信息",
      DownloadTemplate: "下载源文件",
      please_enter_verification_code: "请输入验证码",
      Default_Attributes: "默认属性",
      Include_Customized_Attributes: "包含自定义属性",
      importType: "导入类型"
    },
    Export: {
      export: "导出",
      export_all: "导出全部",
      history: "导出历史",
      time: "导出时间",
      requester: "请求者",
      language: "语言",
      status: "状态",
      action: "操作",
      no_history: "暂无历史记录",
      choose_language: "选择语言",
      loading: "加载中...",
      download: "下载",
      refresh_notice: "单击“刷新”以查看最新状态",
      page_notice: "将商品、属性或其他信息导出到本地文件",
      exporting: "正在准备要下载的商品数据...",
      refresh: "刷新",
      export_all_notice:
        "确定要导出全部商品吗？商品数量众多时此操作可能较为耗时。",
      org: "组织",
      Please_confirm_the_org: "请确认组织",
      confirm_org: "确认组织",
      send: "发送",
      resends: "重新发送({x}秒)",
      resend: "重新发送",
      enter_code: "输入验证码",
      Account_Verification: "账号校验",
      Account_Verification_Tips:
        "为了保护数据安全, 我们需要校验您的账号. 我们将会发送校验码到您的邮箱({x})和手机({y}).",
      exportType: "导出类型"
    }
  }
};
